.emojiPicker {
  height: 70vh;
}

:global(.emoji-or-sticker-header-nav) ~ .emojiPicker {
  height: calc(70vh - 40px);
}